import { render, staticRenderFns } from "./CappedValueDisplay.vue?vue&type=template&id=454b0e5a"
import script from "./CappedValueDisplay.vue?vue&type=script&lang=js"
export * from "./CappedValueDisplay.vue?vue&type=script&lang=js"
import style0 from "./CappedValueDisplay.vue?vue&type=style&index=0&id=454b0e5a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports